/* Faćon – Übersetzung für die gesamte Website (plattformunabhängig).
   Texte: assets/facon-texte.js (window.FACON_TEXTE).

   Markierungen im HTML:
     data-i18n="schluessel"            → Textinhalt
     data-i18n-html="schluessel"       → HTML-Inhalt (nur eigene Texte aus dem Wörterbuch)
     data-i18n-attr="attr:schluessel;attr2:schluessel2"  → Attribute (placeholder, aria-label, alt, …)
     data-i18n-vars='{"name":"Onyx"}'  → Platzhalter {name} in den obigen Texten
     data-i18n-doctitle="schluessel"   → Titel des Browser-Tabs
     data-lang="en"                    → Inhaltsblock nur in dieser Sprache zeigen
                                         (z. B. für Rechtstexte: je Sprache ein Block)
   Sprachwahl: Elemente mit data-set-lang="en"; Anzeige der aktuellen Sprache: [data-sprache-aktuell].
*/
(function () {
  var SPRACHEN = ['de', 'en', 'nl', 'fr', 'it'];
  var STANDARD = 'de';
  var SPEICHER = 'facon-lang';
  var TEXTE = window.FACON_TEXTE || {};

  function gespeichert() {
    try { var s = localStorage.getItem(SPEICHER); if (SPRACHEN.indexOf(s) !== -1) return s; } catch (e) {}
    return null;
  }
  function erkennen() {
    var s = gespeichert();
    if (s) return s;
    var liste = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language || STANDARD];
    for (var i = 0; i < liste.length; i++) {
      var c = String(liste[i] || '').toLowerCase().split('-')[0];
      if (SPRACHEN.indexOf(c) !== -1) return c;
    }
    return STANDARD;
  }

  var aktuell = erkennen();

  function t(key, vars, lang) {
    var d = TEXTE[lang || aktuell] || {};
    var v = d[key];
    if (v == null) v = (TEXTE[STANDARD] || {})[key];
    if (v == null) return null;
    if (vars) v = v.replace(/\{(\w+)\}/g, function (m, n) { return vars[n] != null ? vars[n] : m; });
    return v;
  }

  function vars(el) {
    var raw = el.getAttribute('data-i18n-vars');
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function anwenden(root) {
    root = root || document;
    var q = function (sel) { return root.querySelectorAll(sel); };
    q('[data-i18n]').forEach(function (el) {
      var v = t(el.getAttribute('data-i18n'), vars(el));
      if (v != null) el.textContent = v;
    });
    q('[data-i18n-html]').forEach(function (el) {
      var v = t(el.getAttribute('data-i18n-html'), vars(el));
      if (v != null) el.innerHTML = v;
    });
    q('[data-i18n-attr]').forEach(function (el) {
      var vs = vars(el);
      el.getAttribute('data-i18n-attr').split(';').forEach(function (paar) {
        var p = paar.split(':');
        if (p.length < 2) return;
        var v = t(p[1].trim(), vs);
        if (v != null) el.setAttribute(p[0].trim(), v);
      });
    });
    var titel = document.querySelector('[data-i18n-doctitle]');
    if (titel) {
      var tv = t(titel.getAttribute('data-i18n-doctitle'), vars(titel));
      if (tv != null) document.title = tv;
    }
    /* Sprachblöcke: passenden zeigen, sonst Deutsch als Rückfall */
    var gruppen = {};
    q('[data-lang]').forEach(function (el) {
      var g = el.parentNode; (g.__faconId || (g.__faconId = Math.random().toString(36).slice(2)));
      (gruppen[g.__faconId] = gruppen[g.__faconId] || []).push(el);
    });
    Object.keys(gruppen).forEach(function (id) {
      var els = gruppen[id];
      var treffer = els.some(function (el) { return el.getAttribute('data-lang') === aktuell; });
      var ziel = treffer ? aktuell : STANDARD;
      els.forEach(function (el) { el.hidden = el.getAttribute('data-lang') !== ziel; });
    });
    /* Sprachwahl-Anzeige */
    document.querySelectorAll('[data-sprache-aktuell]').forEach(function (el) { el.textContent = aktuell.toUpperCase(); });
    document.querySelectorAll('[data-set-lang]').forEach(function (b) {
      var an = b.getAttribute('data-set-lang') === aktuell;
      b.setAttribute('aria-current', an ? 'true' : 'false');
    });
  }

  function setzen(lang) {
    if (SPRACHEN.indexOf(lang) === -1) return;
    try { localStorage.setItem(SPEICHER, lang); } catch (e) {}
    if (lang === aktuell) { anwenden(); return; }
    aktuell = lang;
    var html = document.documentElement;
    html.classList.add('i18n-wechsel');
    setTimeout(function () {
      html.lang = aktuell;
      anwenden();
      document.dispatchEvent(new CustomEvent('facon:sprache', { detail: { lang: aktuell } }));
      requestAnimationFrame(function () { html.classList.remove('i18n-wechsel'); });
    }, 180);
  }

  /* ---------- Sprachumschalter (Kopfleiste + Handy-Menü) ---------- */
  function umschalter() {
    document.querySelectorAll('[data-sprache]').forEach(function (box) {
      var knopf = box.querySelector('[data-sprache-toggle]');
      var liste = box.querySelector('[data-sprache-liste]');
      function auf(an) {
        box.classList.toggle('offen', an);
        if (knopf) knopf.setAttribute('aria-expanded', an ? 'true' : 'false');
        if (an && liste) { var b = liste.querySelector('[aria-current="true"]') || liste.querySelector('button'); if (b) b.focus(); }
        if (!an && liste && knopf && liste.contains(document.activeElement)) knopf.focus();
      }
      if (knopf) knopf.addEventListener('click', function (e) { e.stopPropagation(); auf(!box.classList.contains('offen')); });
      document.addEventListener('click', function (e) { if (!box.contains(e.target)) auf(false); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && box.classList.contains('offen')) { auf(false); if (knopf) knopf.focus(); }
      });
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-set-lang]');
        if (!b) return;
        e.preventDefault();
        setzen(b.getAttribute('data-set-lang'));
        auf(false);
      });
    });
  }

  window.FaconI18n = { t: function (k, v) { var r = t(k, v); return r == null ? k : r; }, sprache: function () { return aktuell; }, setzen: setzen, anwenden: anwenden };

  function start() {
    document.documentElement.lang = aktuell;
    anwenden();
    umschalter();
    document.documentElement.classList.remove('i18n-lade');
    document.dispatchEvent(new CustomEvent('facon:sprache', { detail: { lang: aktuell, start: true } }));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
